import type { RealtimeChannel } from '@supabase/supabase-js';
import { getSupabase } from './supabaseClient';

type Cleanup = () => void;

interface SubscribeOptions {
  table: string;
  filter?: string;
  event?: 'INSERT' | 'UPDATE' | 'DELETE' | '*';
}

export function subscribeToTable(
  options: SubscribeOptions,
  onChange: (payload: unknown) => void,
): Cleanup {
  const supabase = getSupabase();
  const channelName = `${options.table}-${options.filter ?? 'all'}-${Math.random()
    .toString(36)
    .slice(2, 8)}`;

  const channel: RealtimeChannel = supabase
    .channel(channelName)
    .on(
      'postgres_changes' as never,
      {
        event: options.event ?? '*',
        schema: 'public',
        table: options.table,
        ...(options.filter ? { filter: options.filter } : {}),
      },
      (payload: unknown) => {
        onChange(payload);
      },
    )
    .subscribe();

  return () => {
    void supabase.removeChannel(channel);
  };
}
